import { Fragment, useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap'
import MUIDataTable, { MUIDataTableOptions } from 'mui-datatables';
import { FaCheck, FaTimes } from 'react-icons/fa'
import { PROFILE_WINNERHISTORY } from '../../constant/menuAndProfile';
import { IReduxStateData } from '../../interfaces/redux';
import { useSelector } from 'react-redux';

interface IWinnerHistory {
    dealDetail: Array<any>,
    winnerList: Array<any>,
    selectedSponsor: string,
    selectedDeal: any,
    openSelectOption: (open: boolean) => void
}

interface IData {
    index?: number;
    user?: string;
    match_title?: string;
    tp_name?: string;
    award_value?: string;
    award_start_date?: string;
    award_end_date?: string;
    is_redeemed?: number;
    redeemed_by?: string;
}

export const WinnerHistory = (props: IWinnerHistory) => {
    const [finalData, setFinalData] = useState<(string | number | undefined)[][]>([]);
    const [results, setResults] = useState<IData[]>([]);
    const [changeFlag, setFlag] = useState<boolean>(true);
    const [currentDealDetail, setCurrentDealDetail] = useState<any>({})
    const globalState = useSelector((state: IReduxStateData) => state);
    const selectedLanguage = globalState?.selectedLang;
    useEffect(() => {
        if (props?.dealDetail && props?.selectedDeal) {
            props?.dealDetail?.forEach((dData: any) => {
                if (dData?.uuid === props?.selectedDeal) {
                    setCurrentDealDetail(dData)
                }
            })
        }
    }, [props?.dealDetail, props?.dealDetail.length, props?.selectedDeal])
    useEffect(() => {
        if (props.winnerList) {
            let data: any[] = [];
            let array: (string | number | undefined)[][];
            // eslint-disable-next-line array-callback-return
            props?.winnerList?.map((winnerData: any, index: number) => {
                data.push({
                    index: index + 1,
                    user: winnerData?.user_name,
                    match_title: winnerData?.match_title,
                    tp_name: winnerData?.tp_name,
                    award_value: winnerData?.award_value,
                    award_start_date: new Date(winnerData?.award_start_date).toLocaleTimeString() + " " + new Date(winnerData?.award_start_date).toLocaleDateString(),
                    award_end_date: new Date(winnerData?.award_end_date).toLocaleTimeString() + " " + new Date(winnerData?.award_end_date).toLocaleDateString(),
                    is_redeemed: winnerData?.is_redeemed,
                    redeemed_by: winnerData?.redeemed_by
                })
            })
            setResults(data)
            if (data) {
                if (data.length) {
                    array = data?.map(result => [result.index, result.user, result.match_title || "", result.tp_name || '', result?.award_value || '', result?.award_start_date || "", result?.award_end_date || "", result?.is_redeemed || "", result?.redeemed_by, result?.ActionRedeem]);
                    // data = array;
                    setFinalData(array)
                } else {
                    setFinalData([])
                }
            }
        }
        setFlag(!changeFlag)
    }, [props.winnerList])
    const columns = [
        { name: PROFILE_WINNERHISTORY[selectedLanguage].no, options: { filter: false, fullWidth: true } },
        { name: PROFILE_WINNERHISTORY[selectedLanguage].user, options: { filter: false } },
        { name: PROFILE_WINNERHISTORY[selectedLanguage].match, options: { filter: true } },
        { name: PROFILE_WINNERHISTORY[selectedLanguage].team_player, options: { filter: true } },
        { name: PROFILE_WINNERHISTORY[selectedLanguage].offer, options: { filter: true } },
        { name: PROFILE_WINNERHISTORY[selectedLanguage].offer_from, options: { filter: false } },
        { name: PROFILE_WINNERHISTORY[selectedLanguage].offer_to, options: { filter: false } },
        {
            name: PROFILE_WINNERHISTORY[selectedLanguage].redeemed, options: {
                filter: true,
                customBodyRender: (value: any, tableMeta: { rowData: any; }, updateValue: any) => {
                    return (
                        <Fragment>
                            {value ? <FaCheck />
                                :
                                <FaTimes />
                            }
                        </Fragment>
                    );
                }
            }
        },
        {
            name: PROFILE_WINNERHISTORY[selectedLanguage].redeemed_by, options: { filter: true }
        }
    ];
    const options: MUIDataTableOptions = {
        filter: true,
        filterType: "dropdown",
        responsive: 'simple',
        jumpToPage: true,
        fixedSelectColumn: false,
        fixedHeader: false,
        pagination: true,
        selectableRows: 'none', // used to hide selction of rows
        rowsPerPageOptions: [100, 200, 300, 400],
        rowsPerPage: 100,
        // search: true,
        // download: true,
        // print: true,
        // viewColumns: true,
        // filter: true,
        // filterType: "dropdown",
        // responsive: "vertical",
        onTableChange: (action, state) => {
            console.log(action);
            console.dir(state);
        }
    };
    return (
        <Fragment key={changeFlag ? "true" : "false"}>
            <div className='right-side-header-main'>
                <div className='right-side-header'>{PROFILE_WINNERHISTORY[selectedLanguage].winner_history}
                    {/* <div className="material-dropdown-select header-toggle-button">
                        <Button
                            onClick={() => { props.openSelectOption(true) }}
                            variant="primary" className='btn btn-dark theme-background-dark-black theme-white rounded-sm py-2 font-16' autoFocus>
                            Toggle Data
                        </Button>
                    </div > */}
                </div>
            </div>
            <hr />
            <Row className='pt-2'>
                <Col sm={12} className='react-table-kitchen-wrapper theme-dark-black'>
                    <div className="table-wrapper" key={changeFlag ? "true" : "false"} style={{ 'flexGrow': 1 }}>
                        {finalData ?
                            // <ThemeProvider theme={createTheme()}>
                            <MUIDataTable
                                title={(props?.selectedSponsor ? props?.selectedSponsor + " - " : "") + (currentDealDetail?.match_title ? (currentDealDetail?.match_title + " & ") : "") + (currentDealDetail?.tp_name || "")}
                                data={finalData}
                                columns={columns}
                                options={options}
                            />
                            // </ThemeProvider>
                            : null
                        }
                    </div>
                </Col>
            </Row>
        </Fragment>
    )
}
